import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

import {ModelGroupDropdownComponent} from '../../components/DomainData/ModelGroupDropdown.component';
import {ModelDropdownComponent} from '../../components/DomainData/ModelDropdown.component';
import {EquipmentGraphicsDropdownComponent} from '../../components/DomainData/EquipmentGraphicsDropdown.component';

//constants
import { Constants }         from '../../constants/Constants';

//baseclasses
import { BaseEditComponent }         from '../../baseclasses/BaseEdit.component';

@Component({
  selector: 'my-fountainlineitem-edit',
  templateUrl: './FountainLineItemEdit.component.html',
  providers: [{provide: BaseEditComponent, useExisting: forwardRef(() => FountainLineItemEditComponent)}]
})
export class FountainLineItemEditComponent extends BaseEditComponent {

    public displayDialog: boolean;

    fountainLineItemForm: FormGroup;

    @Input() public requireModelGroup: boolean;
    @Input() public requireModel: boolean;
    @Input() public requireEquipmentGraphics: boolean;
    @Input() public requireEquipmentLocation: boolean;
    @Input() public requireNumberOfUnits: boolean;

    @Input() public lineItem: ent.FountainLineItem;

    @ViewChild(ModelGroupDropdownComponent) public modelGroupDropdown: ModelGroupDropdownComponent;
    @ViewChild(ModelDropdownComponent) public modelDropdown: ModelDropdownComponent;
    @ViewChild(EquipmentGraphicsDropdownComponent) public equipmentGraphicsDropdown: EquipmentGraphicsDropdownComponent;

    @Output() onOK = new EventEmitter();

    constructor(fb: FormBuilder) 
    { 
        super();
        let group = {
          'modelGroup' : '',
          'model' : '',
          'equipmentGraphics' : '',
          'equipmentLocation' : '',
          'numberOfUnits' : '',
          'materialNumber' : {value:'', disabled: "true"},
          'conaModelGroup' : {value:'', disabled: "true"}
        };
        
        this.fountainLineItemForm = fb.group(group);
        

    }


    ngOnInit(): void {
        if(this.requireModelGroup) {
            this.fountainLineItemForm.controls['modelGroup'].setValidators(Validators.required);
        }

        if(this.requireModel) {
            this.fountainLineItemForm.controls['model'].setValidators(Validators.required);
        }

        if(this.requireEquipmentGraphics) {
            this.fountainLineItemForm.controls['equipmentGraphics'].setValidators(Validators.required);
        }

        if(this.requireEquipmentLocation) {
            this.fountainLineItemForm.controls['equipmentLocation'].setValidators(Validators.required);
        }

        if(this.requireNumberOfUnits) {
            this.fountainLineItemForm.controls['numberOfUnits'].setValidators(Validators.required);
        }
    }

    onHide(){
        this.displayDialog = false;
    }

    onOKClick(event: any){
        
        this.onOK.emit();
        
        this.displayDialog = false;

    }

    modelChange(event: any){
        this.lineItem.ModelID = event;
        this.setMaterialNumber();
        this.setCONAModelNumber();
    }

    equipmentGraphicsChange(event: any){
        this.lineItem.EquipmentGraphicsID = event;
    }


    modelGroupChange(event: any){
        this.lineItem.ModelGroupID = event;
        this.lineItem.ModelID = null;
        if (event){
            this.modelDropdown.filter.ModelGroupID = event;
            this.modelDropdown.loadOnDemand();
        }
    }

    setMaterialNumber(){
        this.lineItem.MaterialNumber = "";
        if (this.lineItem.ModelGroupID > 0){
            var models = this.modelDropdown.models.filter(x=>x.ID == this.lineItem.ModelID);
            if (models.length > 0){
                this.lineItem.MaterialNumber = models[0].MaterialNumber;
            }
            
        }
    }

    setCONAModelNumber(){
        this.lineItem.CONAModelGroup = "";
        if (this.lineItem.ModelGroupID > 0){
            var models = this.modelDropdown.models.filter(x=>x.ID == this.lineItem.ModelID);
            if (models.length > 0){
                this.lineItem.CONAModelGroup = models[0].CONAModelGroup;
            }
        }
    }


}